import RoomLayoutIconPath from "@ingka/ssr-icon/paths/room-layout";

export default RoomLayoutIconPath;
